/* eslint-disable react/style-prop-object */
import { useState, useEffect } from "react";
import axios from "axios";
import "./Resume.css";
import { baseUrl } from "../../config/api";
import { SkeletonResumeSection, SkeletonSkills } from "../../Components";

const Resume = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [resumeData, setResumeData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${baseUrl}/resume.json`);
        setResumeData(res.data);
        setLoading(false);
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [loading]);

  return (
    <>
      {/* #RESUME */}
      <article className="resume" data-page="resume">
        <header>
          <h2 className="h2 article-title">Resume</h2>
        </header>
        {loading ? (
          <>
            <SkeletonResumeSection />
            <SkeletonResumeSection />
            <SkeletonSkills />
          </>
        ) : (
          <>
            {resumeData.sections.map((sec, idx) => (
              <section className="timeline" key={idx}>
                <div className="title-wrapper">
                  <div className="icon-box">
                    <ion-icon name={sec.icon}></ion-icon>
                  </div>
                  <h3 className="h3">{sec.title}</h3>
                </div>
                <ol className="timeline-list">
                  {sec.items.map((i, idx) => (
                    <li className="timeline-item" key={idx}>
                      <h4 className="h4 timeline-item-title">{i.title}</h4>
                      <span>{i.date}</span>
                      <p className="timeline-text">{i.description}</p>
                    </li>
                  ))}
                </ol>
              </section>
            ))}

            {/* skills */}
            <section className="skill">
              <h3 className="h3 skills-title">My skills</h3>
              <ul className="skills-list content-card">
                {resumeData.skills.map((skill, idx) => (
                  <li className="skills-item" key={idx}>
                    <div className="title-wrapper">
                      <h5 className="h5">{skill.name}</h5>
                      <data value={skill.value}>{skill.value}%</data>
                    </div>
                    <div className="skill-progress-bg">
                      <div
                        className="skill-progress-fill"
                        style={{ width: `${skill.value}%` }}
                      ></div>
                    </div>
                  </li>
                ))}
              </ul>
            </section>
          </>
        )}

        {/* حالة الخطأ */}
        {error && <p style={{ color: "red" }}>{error}</p>}

        {/* حالة عدم وجود بيانات */}
        {!loading && !error && !resumeData && <p>No data available.</p>}
      </article>
    </>
  );
};

export default Resume;
